import React from 'react'
import HeroAbout from '../Component/AboutUs/HeroAbout'
import Aboutt from '../Component/AboutUs/Aboutt'
import History from '../Component/AboutUs/History'
import Founder from '../Component/AboutUs/Founder'



const About = () => {
    return (
        <>
        <HeroAbout/>
        <History/>
        <Founder/>
        <Aboutt/>
        
        {/* <Staff/> */}
        </>
    )
}

export default About
